const askquestion = {
    // Header Section
    "discover_your": "Get Your",
    "ask_question": "Ask Question",
    "personalized_answers": "Personalized Astrological Answers",
    "ask_question_description": "Ask any specific question about your life and get detailed astrological answers. Our expert astrologers provide personalized insights based on your birth chart with practical guidance and remedial solutions.",

    // Service Information
    "enter_details_for_question": "Enter Your Details & Question",
    "personalized_question_answer": "Personalized Question Answer",
    "service_price": "Service Price",
    "personalized_question_answer_note": "Expert astrological answer to your specific question with guidance",

    // Form Fields
    "full_name": "Full Name",
    "enter_full_name": "Enter your full name",
    "name_question_context": "Your name helps provide personalized context for your question",
    "email_address": "Email Address",
    "enter_email_address": "Enter your email address",
    "phone_number": "Phone Number",
    "enter_phone_number": "Enter your phone number",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "other": "Other",
    "date_of_birth": "Date of Birth",
    "birth_date_question_context": "Essential for astrological context and accurate answer",
    "your_question": "Your Question",
    "enter_your_question": "Enter your specific question here...",
    "question_guidance": "Be specific and clear. Ask about career, love, finance, health, family, or any life matter",
    "question_category": "Question Category",
    "select_category": "Select question category",
    "career_question": "Career & Business",
    "love_relationship_question": "Love & Relationships",
    "finance_question": "Finance & Money",
    "health_question": "Health & Wellness",
    "family_question": "Family & Personal",
    "spiritual_question": "Spiritual & Growth",
    "general_question": "General Life",
    "category_helps_accuracy": "Category selection helps provide more accurate and relevant answers",
    "preferred_language": "Preferred Language",
    "english": "English",
    "hindi": "Hindi",
    "telugu": "Telugu",
    "kannada": "Kannada",
    "language_note": "Your answer will be delivered in the selected language",

    // Core Question Features
    "detailed_answer_explanation": "Detailed Answer & Explanation",
    "astrological_context": "Astrological Context",
    "timing_guidance": "Timing Guidance",
    "remedial_suggestions": "Remedial Suggestions",
    "follow_up_guidance": "Follow-up Guidance",
    "pdf_answer_report": "PDF Answer Report",

    "what_you_get": "What Your Answer Includes",
    "comprehensive_answer": "Comprehensive Answer",
    "astrological_insights": "Astrological Insights",
    "practical_guidance": "Practical Guidance",
    "remedial_solutions": "Remedial Solutions",

    // Actions & Buttons
    "pay_and_get_answer": "Get My Answer",
    "processing_payment": "Processing Payment",
    "processing_request": "Processing Question",

    // Payment & Success Messages
    "thank_you": "Thank You",
    "payment_successful": "Payment Successful!",
    "question_answer_processing": "Your question is being analyzed by our expert astrologers. You'll receive a detailed personalized answer with astrological insights and practical guidance.",
    "order_id": "Order ID",
    "payment_id": "Payment ID",
    "amount_paid": "Amount Paid",

    // Delivery Information
    "delivery_information": "Delivery Information",
    "delivery_time": "Answer Delivery",
    "within_6_hours_delivery_note": "Your detailed answer will be ready within 6 hours",
    "whatsapp_notification": "WhatsApp Updates",
    "whatsapp_delivery_note": "Receive instant notifications on WhatsApp",
    "email_delivery": "Email Delivery",
    "email_delivery_note": "Complete answer delivered to",

    // What You'll Receive
    "what_youll_receive": "Your Answer Package",
    "detailed_answer_report_pdf": "Detailed Answer Report (PDF)",
    "astrological_explanation": "Astrological Explanation",
    "timing_recommendations": "Timing Recommendations",
    "remedial_measures": "Remedial Measures",
    "action_plan_guidance": "Action Plan Guidance",

    // Visual Content
    "sample_question_answer": "Sample Question Answer",
    "expert_answer": "Expert Answer",
    "sample_answer_preview": "Detailed astrological insights with practical guidance and timing",
    "sample_question_preview": "Preview of how our experts answer your specific questions",
    "question_categories": "Question Categories",

    // Question Category Types
    "career": "Career",
    "love": "Love",
    "finance": "Finance",
    "health": "Health",
    "family": "Family",
    "spiritual": "Spiritual",

    // Status & Processing
    "your_question_status": "Your Question Status",
    "processing_your_question": "Analyzing Your Question",
    "question_processing_message": "Our expert astrologers are studying your birth chart and analyzing your question to provide the most accurate and helpful answer.",
    "request_id": "Question ID",
    "status": "Status",
    "processing": "In Progress",
    "pending": "Queued",
    "email_notification_sent": "Confirmation email sent",
    "whatsapp_update_coming": "WhatsApp updates enabled",
    "delivery_within_6_hours": "Answer ready within 6 hours",

    // Support & Contact
    "contact_support": "Contact Question Support",
    "need_help": "Need guidance?",
    "contact_us_at": "Reach us at",

    // Error Messages
    "please_fill_all_required_fields": "Please complete all required fields including your question",
    "payment_failed": "Payment unsuccessful. Please try again.",
    "processing_failed": "Question processing failed. Contact our support team.",

    // Question Types & Examples
    "career_questions_examples": "Career Questions Examples",
    "when_promotion": "When will I get promotion?",
    "job_change_timing": "Should I change my job now?",
    "business_success": "Will my business be successful?",
    "career_path": "Which career path is best for me?",

    "love_questions_examples": "Love Questions Examples",
    "marriage_timing": "When will I get married?",
    "relationship_future": "What is the future of my relationship?",
    "soulmate_meeting": "When will I meet my soulmate?",
    // Example question (renamed to avoid key collision with navbar's 'love_compatibility')
    "love_compatibility_question": "Are we compatible for marriage?",

    "finance_questions_examples": "Finance Questions Examples",
    "money_problems": "When will my financial problems end?",
    "investment_timing": "Is this a good time to invest?",
    "property_purchase": "Should I buy property now?",
    "debt_relief": "When will I be debt-free?",

    "health_questions_examples": "Health Questions Examples",
    "health_recovery": "When will my health improve?",
    "surgery_timing": "Is this a good time for surgery?",
    "chronic_illness": "Will my chronic condition heal?",
    "fitness_goals": "How can I achieve my health goals?",

    // Answer Components
    "question_analysis": "Question Analysis",
    "birth_chart_insights": "Birth Chart Insights",
    "planetary_influences": "Planetary Influences",
    "current_transits": "Current Transit Effects",
    "dasha_analysis": "Dasha Period Analysis",
    "yogas_doshas": "Relevant Yogas & Doshas",

    // Timing Analysis
    "favorable_periods": "Favorable Periods",
    "challenging_periods": "Challenging Periods",
    "optimal_timing": "Optimal Timing",
    "avoid_periods": "Periods to Avoid",
    "gradual_improvement": "Gradual Improvement Timeline",
    "sudden_changes": "Sudden Change Possibilities",

    // Remedial Solutions
    "gemstone_remedies": "Gemstone Remedies",
    "mantra_recommendations": "Mantra Recommendations",
    "charity_suggestions": "Charitable Activities",
    "ritual_guidance": "Ritual & Puja Guidance",
    "lifestyle_changes": "Lifestyle Modifications",
    "behavioral_adjustments": "Behavioral Adjustments",

    // Practical Guidance
    "action_steps": "Recommended Action Steps",
    "do_and_dont": "Do's and Don'ts",
    "precautions": "Precautions to Take",
    "opportunities": "Opportunities to Watch",
    "preparation_tips": "Preparation Tips",
    "patience_guidance": "When to Be Patient",

    // Follow-up Information
    "progress_tracking": "Progress Tracking",
    "reassessment_timing": "When to Reassess",
    "additional_questions": "Related Questions to Consider",
    "ongoing_guidance": "Ongoing Guidance",
    "support_resources": "Support Resources",
    "expert_consultation": "Expert Consultation Available",

    // Question Quality Guidelines
    "specific_questions": "Ask Specific Questions",
    "avoid_yes_no": "Avoid Simple Yes/No Questions",
    "include_context": "Include Relevant Context",
    "one_main_question": "Focus on One Main Question",
    "clear_timeline": "Mention Desired Timeline",
    "personal_concerns": "Express Personal Concerns",

    // Answer Accuracy Factors
    "birth_time_accuracy": "Birth Time Accuracy Important",
    "current_circumstances": "Current Life Circumstances",
    "personal_efforts": "Personal Efforts Matter",
    "free_will_factor": "Free Will Considerations",
    "karmic_influences": "Karmic Influences",
    "divine_grace": "Divine Grace Factor",

    // Special Question Categories
    "urgent_questions": "Urgent Life Questions",
    "long_term_planning": "Long-term Life Planning",
    "decision_making": "Important Decision Making",
    "crisis_management": "Crisis & Challenge Management",
    "opportunity_evaluation": "Opportunity Evaluation",
    "relationship_counseling": "Relationship Guidance",

    // Confidentiality
    "privacy_assurance": "Complete Privacy Assured",
    "confidential_handling": "Confidential Question Handling",
    "secure_communication": "Secure Communication",
    "expert_discretion": "Expert Discretion Maintained",
    "no_judgment": "Non-judgmental Approach",
    "supportive_guidance": "Supportive & Compassionate Guidance"
};

export default askquestion;
